import { render, staticRenderFns } from "./FormEmployeeFone.vue?vue&type=template&id=3136b0e4"
import script from "./FormEmployeeFone.vue?vue&type=script&lang=js"
export * from "./FormEmployeeFone.vue?vue&type=script&lang=js"
import style0 from "./FormEmployeeFone.vue?vue&type=style&index=0&id=3136b0e4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports